import axios from './axios';

export default class OffersService {
  static createOffer(payload) {
    return axios.post(window.entityCabinetSettings.openApi.url + '/api/offer/create', payload);
  }

  static getOffersList(status) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/offer/unauthorized-list${status ? `/?status=${status}` : ''}`);
  }

  static updateOffersList(params) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/offer/unauthorized-list/?status=${params.status}&page=${params.page}`);
  }

  static getLenderOffersList(params) {
    return axios.get(window.entityCabinetSettings.openApi.url + `/api/offer/personal-list?size=${params?.size}&page=${params?.page}`);
  }

  static changeOfferStatus(data) {
    return axios.post(window.entityCabinetSettings.openApi.url + `/api/offer/change-status/${data.public_id}`, { status: data.status });
  }
}